export const DOCUMENT_REGISTER_TYPE_LIST_PATH = "/document-register/types";
